{
  "common.close": "Fermer",
  "common.athleteFallback": "athlète {id}",
  "splash.title": "{app} — visualisation animée d'activités",
  "splash.tagline": "Vos données Strava&nbsp;en mouvement",
  "splash.demo": "Démo",
  "tab.query.title": "Carte de {name}",
  "tab.query.heading": "Recherche d'activités :",
  "tab.query.optDays": "derniers jours",
  "tab.query.optActivities": "dernières activités",
  "tab.query.optIds": "ID d'activités",
  "tab.query.optDates": "Période",
  "tab.query.idsPlaceholder": "saisissez les ID d'activités ici",
  "tab.query.after": "Après :",
  "tab.query.before": "Avant :",
  "tab.query.autozoom": "Zoom auto <i class=\"hf hf-bullseye\"></i> sur la recherche après l'import",
  "tab.query.queryButton": "<i class=\"hf hf-cloud-download\"></i> Rechercher",
  "tab.query.createAccount": "Créez un compte ou connectez-vous.",
  "tab.query.sports": "Sports :",
  "tab.query.allSports": "Tous les sports",
  "tab.query.sportsExcept": "Tous sauf",
  "tab.query.sportsNone": "Aucun",
  "tab.query.loadingSports": "Chargement des sports…",
  "tab.query.sportsFailed": "Impossible de charger les sports de cette carte",
  "tab.query.noSports": "Aucune activité pour l'instant",
  "tab.activities.title": "Activités affichées",
  "tab.activities.clearSelection": "Effacer la sélection",
  "tab.activities.renderSelected": "Afficher la sélection",
  "tab.activities.zoomToSelection": "<i class=\"fas fa-search-plus\"></i> <i class=\"far fa-object-group\"></i> <i class=\"fas fa-search-minus\"></i> Zoomer sur la sélection",
  "tab.controls.title": "Réglages de la couche",
  "tab.controls.timescale": "Échelle de temps <i>&tau;</i>",
  "tab.controls.timescaleHint": "vitesse de lecture",
  "tab.controls.period": "Période <i>T</i>",
  "tab.controls.periodHint": "activité ~ modèle",
  "tab.controls.dotSize": "Taille des points",
  "tab.controls.pathWidth": "Épaisseur des tracés",
  "tab.controls.pathWidthHint": "zéro masque les tracés",
  "tab.controls.colors": "Couleurs",
  "tab.controls.colorsHint": "faire pivoter la palette",
  "tab.controls.shadows": "Ombres",
  "tab.profile.loginTitle": "Connexion",
  "tab.profile.anonNote": "Connectez-vous avec Strava pour voir vos propres activités et gérer votre compte Heatflask.",
  "tab.profile.loginLink": "Se connecter avec Strava",
  "tab.profile.editOnStrava": "Modifier votre profil sur Strava",
  "tab.profile.indexNote": "Nous indexons le résumé de vos activités pour un accès rapide.",
  "tab.profile.viewIndex": "Voir l'index",
  "tab.profile.sharedMaps": "Cartes partagées",
  "tab.profile.sharedMapsNote": "Désactivé : vous seul voyez vos activités dans Heatflask. Activé : toute personne disposant d'un lien vers votre carte voit les activités que vous avez rendues publiques sur Strava. Vos activités privées restent privées dans tous les cas. <a id=\"profile-privacy-link\" href=\"#\" target=\"_blank\" rel=\"noopener\">Comment fonctionne la confidentialité</a>",
  "tab.profile.logout": "Se déconnecter",
  "tab.profile.deleteAccount": "Supprimer le compte",
  "tab.profile.deleteConfirm": "Supprimer votre compte Heatflask ?\n\nCela retire vos activités indexées et révoque l'accès de Heatflask à vos données Strava. L'opération est irréversible.",
  "tab.profile.languageHeading": "Langue",
  "tab.profile.languageAuto": "Automatique",
  "tab.profile.translateNote": "<a id=\"translate-link\" target=\"_blank\" rel=\"noopener\">Aidez-nous à corriger ou à ajouter des traductions !</a>",
  "tab.profile.unitsHeading": "Unités",
  "tab.profile.unitsAuto": "Automatique",
  "tab.profile.unitsMetric": "Métrique (km, m)",
  "tab.profile.unitsImperial": "Impérial (mi, ft)",
  "tab.profile.textSizeHeading": "Taille du texte",
  "tab.profile.textSmaller": "Plus petit",
  "tab.profile.textReset": "Normale",
  "tab.profile.textLarger": "Plus grand",
  "tab.profile.mapDefaultsHeading": "Réglages par défaut de la carte",
  "tab.profile.mapDefaultsNote": "Commencer avec ce fond de carte, ce relief et ces réglages de calque chaque fois que vous ouvrez une carte dont le lien ne définit pas les siens. Les liens que vous partagez montrent toujours exactement ce que vous voyez.",
  "tab.profile.mapDefaultsSave": "Enregistrer comme mes réglages par défaut",
  "tab.profile.mapDefaultsForget": "Oublier",
  "tab.info.title": "Infos",
  "tab.info.controlsHeading": "Commandes",
  "tab.info.shiftDragKey": "<kbd>Shift</kbd> + glisser",
  "tab.info.shiftDragDesc": "Sélectionner les activités dans un rectangle. Sur écran tactile, touchez d'abord <i class=\"hf-object-group\"></i>, puis faites glisser avec un doigt. La dernière activité sélectionnée affiche son détail, et la liste défile jusqu'à elle.",
  "tab.info.ctrlDragKey": "<kbd>Ctrl</kbd> + glisser",
  "tab.info.ctrlDragDesc": "Faire pivoter et incliner la carte en 3D, ou utiliser deux doigts",
  "tab.info.spaceKey": "<kbd>Space</kbd>",
  "tab.info.spaceDesc": "Ouvrir ou fermer le panneau latéral",
  "tab.info.arrowsKey": "<kbd>&uarr;</kbd> <kbd>&darr;</kbd>",
  "tab.info.arrowsDesc": "Onglet précédent ou suivant",
  "tab.info.escKey": "<kbd>Esc</kbd>",
  "tab.info.escDesc": "Fermer le panneau latéral",
  "tab.info.liveUrlHeading": "URL vivante",
  "tab.info.liveUrlDesc": "La vue de la carte et les réglages de l'animation sont conservés dans l'URL de la page : qui que vous en preniez pour destinataire verra exactement la même vue.",
  "tab.info.videoHeading": "Export vidéo",
  "tab.info.videoDesc": "Le bouton <i class=\"hf-video-camera\"></i> enregistre l'animation en MP4 : touchez-le, ajustez le cadre sur la portion de carte voulue, puis touchez de nouveau pour enregistrer. Un cycle complet de l'animation est enregistré, si bien que la vidéo boucle sans raccord ; un cycle de plus de {max} secondes (la vidéo la plus longue acceptée par Strava) est coupé à {max}.",
  "tab.info.contributeHeading": "Contribuer",
  "tab.info.sponsor": "<i class=\"hf-github\"></i> Devenir sponsor sur GitHub",
  "tab.info.contactsHeading": "Contacts",
  "map.basemapAndTerrain": "Fond de carte et relief",
  "map.pauseAnimation": "Mettre l'animation en pause",
  "map.resumeAnimation": "Reprendre l'animation",
  "capture.record": "Enregistrer la vidéo (boucle de {period} s)",
  "capture.recordTruncated": "Enregistrer la vidéo (un cycle dure {period} s ; seules les {max} premières s seront enregistrées)",
  "capture.recordArea": "Enregistrer la zone dans le cadre",
  "capture.stop": "Arrêter l'enregistrement",
  "capture.selectionTooSmall": "la sélection est trop petite",
  "capture.saved": "{name} enregistré ({size})",
  "capture.cancelled": "enregistrement annulé",
  "capture.failed": "échec de l'enregistrement : {error}",
  "capture.loadingEncoder": "chargement de l'encodeur…",
  "capture.waitingForMap": "en attente du chargement de la carte…",
  "capture.encoding": "encodage… {percent} %",
  "capture.finalizing": "finalisation…",
  "share.title": "Partager un lien vers cette carte",
  "share.copied": "lien copié",
  "share.copiedUnshared": "lien copié — mais votre carte n’est pas partagée, personne d’autre ne peut donc l’ouvrir. Activez « Cartes partagées » pour changer cela.",
  "share.unshared": "Votre carte n’est pas partagée, personne d’autre ne peut donc ouvrir ce lien. Activez « Cartes partagées » pour changer cela.",
  "share.copyThis": "Copiez ce lien :",
  "update.available": "Une nouvelle version de Heatflask est disponible.",
  "update.reload": "Recharger",
  "import.title": "Import en cours",
  "import.stop": "Arrêter",
  "import.stopping": "arrêt en cours…",
  "import.contacting": "connexion à Strava…",
  "import.countOf": "Activités : {received} sur {total}",
  "import.count": "Activités : {received}",
  "import.waitStrava": "En pause jusqu'à {time} : limite de téléchargement de Strava. Laissez cette page ouverte ; recharger n'accélère rien.",
  "import.waitRationed": "Vos téléchargements rapides du jour sont épuisés. La suite reprend à {time}, plus lentement. Laissez cette page ouverte.",
  "import.dailyLimit": "La limite quotidienne de téléchargement de Strava est atteinte. Réessayez après {time}.",
  "import.dailyRationed": "Vous avez utilisé votre part de téléchargements Strava pour aujourd'hui. Réessayez après {time}.",
  "import.noActivitiesYet": "Votre compte Strava n'a encore aucune activité. Enregistrez-en une ou importez-la sur Strava, et elle apparaîtra ici.",
  "table.noActivities": "aucune activité",
  "table.untitled": "(sans titre)",
  "activities.pageTitle": "{app} — index des activités",
  "activities.heading": "Index des activités",
  "activities.fetching": "Récupération des activités...",
  "activities.rateLimit": "Limite de requêtes Strava atteinte ; reprise à {time}",
  "activities.noData": "Désolé, aucune donnée &#128577;",
  "activities.colServerCache": "Tracé en cache sur le serveur (Mongo)",
  "activities.colBrowserCache": "Tracé en cache dans ce navigateur",
  "activities.cachedServer": "Le tracé de {id} est en cache sur le serveur",
  "activities.notCachedServer": "Le tracé de {id} n'est pas en cache sur le serveur",
  "activities.cachedBrowser": "Le tracé de {id} est en cache dans ce navigateur",
  "activities.notCachedBrowser": "Le tracé de {id} n'est pas en cache dans ce navigateur",
  "sport.AlpineSki": "Ski alpin",
  "sport.BackcountrySki": "Ski de randonnée",
  "sport.Badminton": "Badminton",
  "sport.Basketball": "Basketball",
  "sport.Canoeing": "Canoë",
  "sport.Cricket": "Cricket",
  "sport.Crossfit": "Crossfit",
  "sport.Dance": "Danse",
  "sport.EBikeRide": "Sortie en vélo électrique",
  "sport.Elliptical": "Elliptique",
  "sport.EMountainBikeRide": "Sortie en VTT électrique",
  "sport.Golf": "Golf",
  "sport.GravelRide": "Sortie gravel",
  "sport.Handcycle": "Handbike",
  "sport.HighIntensityIntervalTraining": "HIIT",
  "sport.Hike": "Randonnée",
  "sport.IceSkate": "Patinage sur glace",
  "sport.InlineSkate": "Roller",
  "sport.Kayaking": "Kayak",
  "sport.Kitesurf": "Kitesurf",
  "sport.MountainBikeRide": "Sortie VTT",
  "sport.NordicSki": "Ski de fond",
  "sport.Padel": "Padel",
  "sport.PhysicalTherapy": "Kinésithérapie",
  "sport.Pickleball": "Pickleball",
  "sport.Pilates": "Pilates",
  "sport.Racquetball": "Racquetball",
  "sport.Ride": "Sortie vélo",
  "sport.RockClimbing": "Escalade",
  "sport.RollerSki": "Ski-roues",
  "sport.Rowing": "Aviron",
  "sport.Run": "Course à pied",
  "sport.Sail": "Voile",
  "sport.Skateboard": "Skateboard",
  "sport.Snowboard": "Snowboard",
  "sport.Snowshoe": "Raquettes",
  "sport.Soccer": "Football",
  "sport.Squash": "Squash",
  "sport.StairStepper": "Stepper",
  "sport.StandUpPaddling": "Stand up paddle",
  "sport.Surfing": "Surf",
  "sport.Swim": "Natation",
  "sport.TableTennis": "Tennis de table",
  "sport.Tennis": "Tennis",
  "sport.TrailRun": "Trail",
  "sport.Velomobile": "Vélomobile",
  "sport.VirtualRide": "Sortie vélo virtuelle",
  "sport.VirtualRow": "Aviron virtuel",
  "sport.VirtualRun": "Course virtuelle",
  "sport.Volleyball": "Volleyball",
  "sport.Walk": "Marche",
  "sport.WeightTraining": "Musculation",
  "sport.Wheelchair": "Fauteuil roulant",
  "sport.Windsurf": "Planche à voile",
  "sport.Workout": "Entraînement",
  "sport.Yoga": "Yoga"
}
